"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const openapi_1 = require("../../../../../openapi");
const Schema = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Factory.Spec';
const SuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'The registry information was stored',
});
/** The serial number is new and encodes no known model. Carries no express-validator field errors. */
const InvalidSerialNumber = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidSerialNumber`, 'INVALID_SERIAL_NUMBER', 'Invalid Serial Number', 'The serial number does not belong to a registered device and encodes no known model. Carries no express-validator field errors.');
const setRegistryInfo = platform_1.HttpApiEndpoint.post('setRegistryInfo') `/factory/registry`
    .setPayload(Schema.RegistryInfoPayload)
    .addSuccess(SuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(InvalidSerialNumber)
    .annotate(platform_1.OpenApi.Title, 'Set Device Registry Info')
    .annotate(platform_1.OpenApi.Description, 'Stores the factory registry information of a device. A known serial number replaces a stored value only when the new one is non-empty and keeps the rest. An empty string counts as not supplied. The handler passes the formatted device to update(), and that record has no providedLocation, so a known serial always gets providedLocation: {} and loses its stored coordinates. The domain schema rejects {}, so a V2 read of that device is 500 and a list query drops it. An unknown serial number is registered, with its model taken from the serial number, and an omitted value stored as null. The factory key is the `key` query parameter and a wrong or missing one is 401. A deployment without a configured factory key rejects every call with 401 at the guard, so the handler check that would answer 500 is never reached. A failed registry write is 500.')
    .middleware(openapi_1.Security.V1FactoryKey)
    .pipe(openapi_1.Error.withV1PublicErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.device.factory')
    .add(setRegistryInfo)
    .prefix('/device')
    .annotate(platform_1.OpenApi.Title, 'Device Factory')
    .annotate(platform_1.OpenApi.Description, 'Endpoints the device factory calls with its shared key')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Device));
//# sourceMappingURL=spec.js.map